import { createApiRequestType, strictObjectAccess } from '@ackee/redux-utils';
import { EntityKey } from 'constants/index';

const apiRequest = createApiRequestType({ modulePrefix: EntityKey.DOCUMENT_CONTRACTS });

export const fetchContractsTypes = strictObjectAccess({ ...apiRequest({ typePrefix: 'FETCH_CONTRACTS_' }) });
